<template>
  <div>
    <view-options elementId="Resumen" />
    <div class="profile-view" id="Resumen">
      <div>
        <div class="lds-ellipsis" v-if="Charging">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <ad-goals
          v-bind:totalImpressions="summaryStats.totalImpressions || 0"
          v-bind:totalClicks="summaryStats.totalClicks || 0"
          v-bind:totalCallClicks="0"
          v-bind:totalDirectionRequest="0"
          v-bind:totalSearchImpressions="0"
          v-bind:totalMapImpressions="0"
          v-bind:totalClicksAddress="0"
          v-bind:totalWebsiteClicks="0"
          v-bind:totalReviewCount="0"
          :wording="wordings"
        ></ad-goals>
        <!-- <h1 @click="evento">hola:{{date1 +" "+ date2}}</h1> -->
        <!-- <p></p>
        <input type="button" value="date1">
        <h1>{{date1}}</h1>
       <input type="text" name="" id="" @change="evento" v-model="date1"> -->

        <impressions
          v-bind:totalImpressions="summaryStats.totalImpressions || 0"
          :yaxis="yaxis"
          :impressions="summaryStats.impressions || []"
        ></impressions>

        <!-- <button @click="exportPDF">holaaaaaaa print</button> -->
      </div>

      <div v-if="AllConversionActions.length">
        <h3>Resumen de Conversiones</h3>
        <conversion-table :conversionArray="AllConversionActions" ></conversion-table>
      </div>

      <ad-type :adsType="summaryStats.adsType || {}"></ad-type>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import { SubscriberService } from "../../services/subscriber.service";
import Impressions from "@/components/Widgets/Impressions.vue";
import ConversionTable from '../../components/ConversionTable'
import AdGoals from "@/components/Widgets/AdGoals.vue";
import ViewOptions from "@/components/ViewOptions.vue";
import AdType from "@/components/Widgets/AdType.vue";

import { mapActions, mapGetters } from "vuex";
//REQUEST

import FormatProducts from "../../shared/util/format-products.util";
import { getConversionActions } from '../../services/conversion_actions';
export default {
  name: "resumen",
  components: {
    AdGoals,
    AdType,
    Impressions,
    ViewOptions,
    ConversionTable
  },
  data() {
    return {
      AllConversionActions: [],
      Charging: true,
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      yaxis: {
        labels: {
          maxWidth: 80
        }
      },
      productData: {
        totalImpressions: 683575,
        totalClicks: 5263
      },
      productView: {
        totalProductData: 0,
        totalSearchesPA: 0,
        mobilePercentage: 0,
        desktopPercentage: 0
      },
      digitalPresence: [],
      googleResults: [],

      adListings: [
        // {
        //   listingIframeUrl:
        //     "http://caribemediadigital-betaui.azurewebsites.net/Get/Index/70894_16_SD",
        //   listingType: "Diamante",
        //   listingUrl:
        //     "https://www.paginasamarillas.com.do/Searchpg.aspx?nombre=Vidrios",
        //   listingCategory: "Vidrios",
        //   listingProfileUrl:
        //     "https://www.paginasamarillas.com.do/aluminio/santo-domingo/plasticos-y-espejos/info/es"
        // }
      ],
      adInteractions: [],
      adsBanners: [],
      fecha: "",
      data: "1"
    };
  },
  watch: {
    date1: async function() {
      const { customerId } = this.$route.query;
      const toDate = this.$store.state.subscriber.date1;
      const fromDate = this.$store.state.subscriber.date2;
      const {
        subscriberId,
        businessUnitId,
        comercialName
      } = this.$route.params;

      await this.GetSummaryStats({
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        context: this,
        customerId,
        bookCode: "SPPG",
        commercialName: comercialName
      });
    },
    date2: async function() {
      const { customerId } = this.$route.query;
      const toDate = this.$store.state.subscriber.date1;
      const fromDate = this.$store.state.subscriber.date2;
      const {
        subscriberId,
        businessUnitId,
        comercialName
      } = this.$route.params;

      await this.GetSummaryStats({
        subscriberId,
        businessUnitId,
        toDate,
        fromDate,
        context: this,
        customerId,
        bookCode: "SPPG",
        commercialName: comercialName
      });
    }
  },
  mounted: async function() {
    const toDate = this.$store.state.subscriber.date1;
    const fromDate = this.$store.state.subscriber.date2;
    const { subscriberId, businessUnitId, comercialName } = this.$route.params;
    const { customerId } = this.$route.query;

    const googleCustomerId = customerId.split(",")[0];

    await this.GetSummaryStats({
      subscriberId,
      businessUnitId,
      toDate,
      fromDate,
      context: this,
      customerId,
      bookCode: "SPPG",
      commercialName: comercialName
    });
    await this.GetProducts({ subscriberId, businessUnitId, context: this });

    const products = new FormatProducts().format(this.products);

    const callsPending = [products];

    const roll = localStorage.getItem("roll");

    if (roll === "Administrator" || roll === "Consulting") {
      const client = new SubscriberService(this).getSubcriber(subscriberId);
      callsPending.push(client);
    }

    Promise.all(callsPending).then(responses => {
      this.$store.commit("FillProducts", responses[0]);
      if (callsPending.length > 1) {
        this.$store.commit("FillClient", responses[1]);
      }
    });

    if (googleCustomerId && googleCustomerId.length) {
      const conversionActionsFiltered = [];

      const ConversionActions = await getConversionActions(googleCustomerId, businessUnitId, fromDate, toDate);

      if (ConversionActions.length > 0) {
        ConversionActions.map(({ conversionActionRows }) => {
          return conversionActionRows.map(actions => {
            if (Number(actions.allConversion)) {
              conversionActionsFiltered.push({
                allConversion: actions.allConversion,
                conversionAction: actions.conversionAction
              });
            }
          });
        });
      }
      this.AllConversionActions = conversionActionsFiltered;
    }

    this.$store.commit("SetCurrentBusiness", { subscriberId, businessUnitId });

    this.cambiar();
  },
  created() {
    const { comercialName } = this.$route.params;
    this.$store.commit("FillClientComercialNameStore", comercialName);
    function topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
    topFunction();
  },
  methods: {
    cambiar() {
      this.Charging = !this.Charging;
    },
    // exportPDF(elem) {
    //   this.$htmlToPaper('printMe');
    // },

    evento: function() {
      alert("hola");
    },
    ...mapActions(["GetSummaryStats", "GetProducts"])
  },
  computed: {
    ...mapGetters(["summaryStats", "products", "date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
@include respond-above(md) {
  .profile-view {
    display: grid;
    grid-template: 1fr / 1fr minmax(300px, 350px);
    grid-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
